import { SVGProps } from 'react'

const EarningIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.7105 16.8351C22.874 16.8351 26.2491 13.4599 26.2491 9.29643C26.2491 5.13297 22.874 1.75781 18.7105 1.75781C14.547 1.75781 11.1719 5.13297 11.1719 9.29643C11.1719 13.4599 14.547 16.8351 18.7105 16.8351Z"
        stroke={props.color ? props.color : 'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7119 11.1795V7.41016"
        stroke={props.color ? props.color : 'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.74805 21.541L6.35364 25.379C7.03104 25.9435 7.88492 26.2527 8.76669 26.2527L20.9087 26.2527C21.7761 26.2527 22.4793 25.5495 22.4793 24.6821C22.4793 22.9473 21.0729 21.541 19.3382 21.541H10.8967"
        stroke={props.color ? props.color : 'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.40202 19.653L8.81551 21.0665C9.59616 21.8472 10.8618 21.8472 11.6425 21.0665C12.4231 20.2859 12.4231 19.0202 11.6425 18.2396L9.44835 16.0454C8.74147 15.3385 7.78273 14.9414 6.78304 14.9414H1.74805"
        stroke={props.color ? props.color : 'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default EarningIcon
